import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="whatsapp-float"
      href="https://wa.me/33671190938"
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-6 right-6 z-[65] flex items-center gap-3"
      aria-label="Nous contacter sur WhatsApp"
    >
      <span className="pointer-events-none hidden translate-x-2 rounded-full border border-[#E2DBCB]/15 bg-[#141619]/95 px-4 py-2 text-xs text-[#B0ABA0] opacity-0 shadow-xl backdrop-blur-md transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block">
        Une question ? Écrivez-nous
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#D4AF37] text-[#0C0D0E] shadow-[0_8px_30px_rgba(212,175,55,0.35)] transition-transform duration-300 group-hover:scale-110">
        <span className="absolute inset-0 animate-ping rounded-full bg-[#D4AF37]/30" />
        <MessageCircle size={24} className="relative" />
      </span>
    </motion.a>
  );
}
